import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Thanks from './views/Thanks.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/thanks',
      name: 'thanks',
      component: Thanks
    },
    {
      path: '/:surveyId/:leadId?',
      name: 'home',
      component: Home
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ],
  linkActiveClass: 'active'
})
